var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.333 0.984375H15.0225V8.19638H21.333V0.984375Z",
    fill: "#2B5B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.8105 8.19531H1.5V18.1118C1.5 18.3509 1.59498 18.5802 1.76404 18.7493C1.93311 18.9183 2.16241 19.0133 2.4015 19.0133H6.909C7.14809 19.0133 7.37739 18.9183 7.54646 18.7493C7.71552 18.5802 7.8105 18.3509 7.8105 18.1118V8.19531Z",
    fill: "#2B5B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.984375H21.333V14.5069C21.333 14.746 21.238 14.9753 21.069 15.1443C20.8999 15.3134 20.6706 15.4084 20.4315 15.4084H15.924C15.6849 15.4084 15.4556 15.3134 15.2865 15.1443C15.1175 14.9753 15.0225 14.746 15.0225 14.5069V11.8024H7.8105V18.1129C7.8105 18.352 7.71552 18.5813 7.54646 18.7503C7.37739 18.9194 7.14809 19.0144 6.909 19.0144H2.4015C2.16241 19.0144 1.93311 18.9194 1.76404 18.7503C1.59498 18.5813 1.5 18.352 1.5 18.1129V0.984375Z",
    stroke: "white",
    strokeWidth: 1.803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8105 8.19531H1.5",
    stroke: "white",
    strokeWidth: 1.803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81055 0.984375V11.8024",
    stroke: "white",
    strokeWidth: 1.803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 8.19531H21.333",
    stroke: "white",
    strokeWidth: 1.803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 0.984375V11.8024",
    stroke: "white",
    strokeWidth: 1.803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactActive);
export default __webpack_public_path__ + "static/media/ContactActive.d6f6bd695b1e7e20baac49bc10cb34a1.svg";
export { ForwardRef as ReactComponent };